// extracted by mini-css-extract-plugin
export default {"container":"To-z","bubbleNav":"Uo-z","graphic":"Vo-z","contact":"Wo-z"};